module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","save":"Speichern"},"en":{}}')
  delete Component.options._Ctor
}
